import { useEffect } from "react";
import { site } from "../config/site";

type SeoProps = {
  title: string;
  description?: string;
  path: string;
};

function setMeta(attribute: "name" | "property", key: string, value: string) {
  let element = document.head.querySelector<HTMLMetaElement>(
    `meta[${attribute}="${key}"]`
  );

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.setAttribute("content", value);
}

export function Seo({ title, description, path }: SeoProps) {
  const fullTitle =
    title === site.brandName ? title : `${title} — ${site.brandName}`;
  const summary = description ?? site.seo.defaultDescription;
  const url = `${site.domain}${path === "/" ? "/" : path}`;

  useEffect(() => {
    document.title = fullTitle;
    setMeta("name", "description", summary);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", summary);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("name", "twitter:card", "summary");

    let canonical = document.head.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]'
    );
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = url;
  }, [fullTitle, summary, url]);

  return null;
}
